import { render, staticRenderFns } from "./MenuUstawienia.vue?vue&type=template&id=0654db4c&scoped=true&"
import script from "./MenuUstawienia.vue?vue&type=script&lang=js&"
export * from "./MenuUstawienia.vue?vue&type=script&lang=js&"
import style0 from "./MenuUstawienia.vue?vue&type=style&index=0&id=0654db4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0654db4c",
  null
  
)

export default component.exports